export function toFormData<T>(formValue: T, put = false) {
    const formData = new FormData();

    for (const key of Object.keys(formValue)) {
        let value = formValue[key];
        if (typeof value === 'boolean') {
            value = value ? '1' : '0';
        }
        if (value) {
            formData.append(key, value);
        }
    }

    if (put) {
        formData.append('_method', 'PUT');
    }

    return formData;
}
